import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./ThemeContext";
import { Dashboard } from "./components/Dashboard";
import { LoginPage } from "./components/LoginPage";
import { CallbackPage } from "./components/CallbackPage";
import { useAuth } from "./AuthContext";
import { CodiffLinksProvider } from "./hooks/useCodiffLinks";

function App() {
	const { user, loading } = useAuth();

	// getUser() is async, so `user` is null before auth is known. Routing on it
	// while loading sends a signed-in user to LoginPage, which redirects to
	// GitLab before we ever find out they had a session.
	if (loading) {
		return (
			<ThemeProvider>
				<div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-app)]">
					<div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent)] border-t-transparent" />
				</div>
			</ThemeProvider>
		);
	}

	return (
		<ThemeProvider>
			<CodiffLinksProvider>
				<Routes>
					<Route path="/callback" element={<CallbackPage />} />
					<Route
						path="/"
						element={user ? <Dashboard /> : <Navigate to="/login" />}
					/>
					<Route
						path="/login"
						element={!user ? <LoginPage /> : <Navigate to="/" />}
					/>
				</Routes>
			</CodiffLinksProvider>
		</ThemeProvider>
	);
}

export default App;
